import Marker from './marker';

const Markers = ({ points, setPopupInfo }: any) =>
  points.map((point: any, i: number) => (
    <Marker color={'white'} backgroundColor={'red'} marker={point} key={i} onClick={() => setPopupInfo(point)} />
  ));
export default Markers;
